export const BUILD_VERSION = '1791750593';
